import router from './router'
import OrderMessages from './localization'

export default {
  router,
  localization: OrderMessages,
}
